import React, { useState, useEffect } from 'react';
import componentStyles from './betCartButton.module.css';
import BetCartService from '../../service/betCartService';
import eventBus from '../../service/eventBus';
import { EVENT_TRIGGER_BET_CART } from '../../utils/constants';
import { FaShoppingCart } from 'react-icons/fa';

/**
 * BetCartButton - Floating button to open bet cart
 * Only visible when there are saved bets
 */
const BetCartButton = () => {
    const [betCount, setBetCount] = useState(0);
    const betCartService = BetCartService.getInstance();

    useEffect(() => {
        // Initial count
        setBetCount(betCartService.getBetCount());

        // Listen for cart updates (we'll emit this event when bets are added/removed)
        const updateCount = () => {
            setBetCount(betCartService.getBetCount());
        };

        // Check for updates periodically (simple approach)
        // In a real app, you might use an event system
        const interval = setInterval(updateCount, 500);

        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        eventBus.emit(EVENT_TRIGGER_BET_CART, true);
    };

    // Only show if there are bets
    if (betCount === 0) {
        return null;
    }

    return (
        <button
            className={componentStyles.betCartButton}
            onClick={handleClick}
            title={`View ${betCount} saved bet${betCount !== 1 ? 's' : ''}`}
        >
            <FaShoppingCart className={componentStyles.cartIcon} aria-hidden="true" />
            {betCount > 0 && (
                <span className={componentStyles.badge}>{betCount > 9 ? '9+' : betCount}</span>
            )}
        </button>
    );
};

export default BetCartButton;
